module.exports = __webpack_public_path__ + "img/cartoon_yiya.67f8572f.png";